<script setup lang="ts">
  import {
    ComboboxItem,
    type ComboboxItemEmits,
    type ComboboxItemProps,
    useForwardPropsEmits
  } from 'reka-ui'
  import type { HTMLAttributes } from 'vue'
  import { cn } from '../../../lib/utils'
  import { computed } from 'vue'

  const props = defineProps<
    ComboboxItemProps & { class?: HTMLAttributes['class'] }
  >()
  const emits = defineEmits<ComboboxItemEmits>()

  const delegatedProps = computed(() => {
    const { class: _, ...rest } = props
    return rest
  })
  const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <ComboboxItem
    data-slot="combobox-item"
    v-bind="forwarded"
    :class="
      cn(
        'data-[highlighted]:bg-accent data-[highlighted]:text-accent-foreground relative flex cursor-pointer select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
        props.class
      )
    "
  >
    <slot />
  </ComboboxItem>
</template>
